// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-breadcrumb[data-v-965d0168]{width:62.1875rem;margin:1.458333rem auto}.el-breadcrumb[data-v-965d0168]{margin-top:.520833rem}", ""]);
// Exports
module.exports = exports;
